import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/learn/courses/$courseId')({
  component: () => <Outlet />,
});
